import { Route, Routes, Navigate } from 'react-router-dom';
import PrivateRoute from '../../utils/PrivateRoute';
import { TableLandingSupportPage } from "../../pages/SupportSystem/TableLandingSupportPage";
import { DetailSupportFormTestPage } from "../../pages/SupportSystem/SupportForm/DetailSupportFormTestPage";
import { DetailSupportFormAnnounce6Page } from "../../pages/SupportSystem/SupportForm/DetailSupportFormAnnounce6Page";
import { ReportAllocatedAndSubsidies38Page } from '../../pages/SupportSystem/Reports/ReportAllocatedAndSubsidies38Page';
import { ReportAllocatedAndSubsidies39Page } from '../../pages/SupportSystem/Reports/ReportAllocatedAndSubsidies39Page';
import { ReportAllocatedAndSubsidies40Page } from '../../pages/SupportSystem/Reports/ReportAllocatedAndSubsidies40Page';
import { ReportAllocatedAndSubsidies41Page } from '../../pages/SupportSystem/Reports/ReportAllocatedAndSubsidies41Page';
import { ReportAllocatedAndSubsidies42Page } from '../../pages/SupportSystem/Reports/ReportAllocatedAndSubsidies42Page';

import { DetailAndAllocateForSkillDevelopmentPage } from '../../pages/SupportSystem/SupportForm/DetailAndAllocateForSkillDevelopmentPage';
import { DetailAndAllocateForEstimatePage } from '../../pages/SupportSystem/SupportForm/DetailAndAllocateForEstimatePage';
import { EntrepreneurAnnounce7FormPage } from "../../pages/SupportSystem/SupportForm/EntrepreneurAnnounce7FormPage";
import { EntrepreneurAnnounce8FormPage } from "../../pages/SupportSystem/SupportForm/EntrepreneurAnnounce8FormPage";
import { EntrepreneurAnnounce9FormPage } from "../../pages/SupportSystem/SupportForm/EntrepreneurAnnounce9FormPage";
import { EntrepreneurAnnounce10FormInnovationPage } from "../../pages/SupportSystem/SupportForm/EntrepreneurAnnounce10FormInnovationPage";
import { DetailInnovationPersonTrainAndExpectedPage } from "../../pages/SupportSystem/SupportForm/DetailInnovationPersonTrainAndExpectedPage"
import { DetailInnovationPersonTrainPage } from "../../pages/SupportSystem/SupportForm/DetailInnovationPersonTrainPage"
import { DetailInnovationCoursePage } from "../../pages/SupportSystem/SupportForm/DetailInnovationCoursePage";
import { EntrepreneurCh24Announce10FormPage } from '../../pages/SupportSystem/SupportForm/EntrepreneurCh24Announce10FormPage';
import { ApproveInnovationAnnouce10Page } from '../../pages/SupportSystem/SupportForm/ApproveInnovationAnnouce10Page';
import { ApproveInnovationAnnouce10DetailPage } from '../../pages/SupportSystem/SupportForm/ApproveInnovationAnnouce10DetailPage';
import { EstimateAnnounce11FormPage } from '../../pages/SupportSystem/SupportForm/EstimateAnnounce11FormPage';
import { OperationReportForm3Page } from "../../pages/SupportSystem/OperationReportForm/OperationReportForm3Page"
import { OperationReportForm31Page } from "../../pages/SupportSystem/OperationReportForm/OperationReportForm31Page"
import { OperationReportForm32Page } from "../../pages/SupportSystem/OperationReportForm/OperationReportForm32Page"
import { AdminCheckOperationReportsPage } from '../../pages/SupportSystem/OperationReportForm/AdminCheckOperationReportsPage';
import { SupportAdminConditionPage } from '../../pages/Admin/SupportAdminConditionPage';
import { SupportAdminCheckPage } from '../../pages/Admin/SupportAdminCheckPage';
import { SupportAdminDetailPage } from '../../pages/Admin/SupportAdminDetailPage';

import { ViewSupport4Page } from "../../pages/SupportSystem/ViewReports/ViewSupport4Page";
import { ViewSupport41Page } from "../../pages/SupportSystem/ViewReports/ViewSupport41Page";
import { ViewSupport42Page } from "../../pages/SupportSystem/ViewReports/ViewSupport42Page";
import { ViewSupport43Page } from "../../pages/SupportSystem/ViewReports/ViewSupport43Page";
import { ViewSupport44Page } from "../../pages/SupportSystem/ViewReports/ViewSupport44Page";
import { ViewSupport45Page } from "../../pages/SupportSystem/ViewReports/ViewSupport45Page";
import { ViewSupport46Page } from "../../pages/SupportSystem/ViewReports/ViewSupport46Page";
import { ViewSupport47Page } from "../../pages/SupportSystem/ViewReports/ViewSupport47Page";
import { ViewSupport48Page } from "../../pages/SupportSystem/ViewReports/ViewSupport48Page";
import { ViewSupport49Page } from "../../pages/SupportSystem/ViewReports/ViewSupport49Page";
import { ViewSupport410Page } from "../../pages/SupportSystem/ViewReports/ViewSupport410Page";
import { ViewSupport411Page } from "../../pages/SupportSystem/ViewReports/ViewSupport411Page";
import { AddViewSupport47Page } from "../../pages/SupportSystem/ViewReports/AddViewSupport47Page";
import { AddViewSupport48Page } from "../../pages/SupportSystem/ViewReports/AddViewSupport48Page";
import { AddViewSupport49Page } from "../../pages/SupportSystem/ViewReports/AddViewSupport49Page";
import { AddViewSupport410Page } from "../../pages/SupportSystem/ViewReports/AddViewSupport410Page";
import { AddViewSupport411Page } from "../../pages/SupportSystem/ViewReports/AddViewSupport411Page";
import { SupportDetailAdminCheckTransferPage } from "../../pages/Admin/SupportDetailAdminCheckTransferPage";
import { Report55Page } from '../../pages/SupportSystem/Reports/Report55Page';
import { Report56Page } from '../../pages/SupportSystem/Reports/Report56Page';
import { Report57Page } from '../../pages/SupportSystem/Reports/Report57Page';
import { Report58Page } from '../../pages/SupportSystem/Reports/Report58Page';
import { Report59Page } from '../../pages/SupportSystem/Reports/Report59Page';
import { Report60Page } from '../../pages/SupportSystem/Reports/Report60Page';
import { Report61Page } from '../../pages/SupportSystem/Reports/Report61Page';
import { Report62Page } from '../../pages/SupportSystem/Reports/Report62Page';
import { Report63Page } from '../../pages/SupportSystem/Reports/Report63Page';

import { ListReportSupportPage } from '../../pages/SupportSystem/Reports/ListReportSupportPage';
import { ListReportSupportRequestPage } from '../../pages/SupportSystem/Reports/ListReportSupportRequestPage';
import { ListReportSupportSubmitRequestPage } from '../../pages/SupportSystem/Reports/ListReportSupportSubmitRequestPage';
import { ListReportViewSupport4Page } from '../../pages/SupportSystem/Reports/ListReportViewSupport4Page';

import { TransferforofficerPage } from '../../pages/SupportSystem/SupportForm/TransferforofficerPage';
import { Transferforofficer13Page } from '../../pages/SupportSystem/SupportForm/Transferforofficer13Page';

import { BudgetYearLimitDetailPage } from '../../pages/SupportSystem/Admin/BudgetYearLimitDetailPage';

import { ApprovalConsiderationAnnounceEightPage } from "../../pages/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceEightPage";
import { ApprovalConsiderationAnnounceFourPage } from "../../pages/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceFourPage";
import { ApprovalConsiderationAnnounceElevenPage } from "../../pages/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceElevenPage";
import { ApprovalConsiderationAnnounceFivePage } from "../../pages/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceFivePage";
import { ApprovalConsiderationAnnounceNinePage } from "../../pages/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceNinePage";
import { ApprovalConsiderationAnnounceSevenPage } from "../../pages/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceSevenPage";
import { ApprovalConsiderationAnnounceSixPage } from "../../pages/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceSixPage";

import { MoverSupportIdPage } from '../../pages/SupportSystem/MoveSupportId/MoverSupportIdPage';
import { ManageCriteriaPage } from '../../pages/SupportSystem/ManageCriteriaPage';
import { ImportListMemberAnnounce4Page } from '../../pages/SupportSystem/ImportListMemberAnnounce4Page';

import { CreateSupportAnnounce4Page } from '../../pages/Officer/CreateSupportAnnounce4Page';
import { CreateSupportAnnounce5Page } from '../../pages/Officer/CreateSupportAnnounce5Page';
import { CreateSupportAnnounce6Page } from '../../pages/Officer/CreateSupportAnnounce6Page';
import { CreateSupportAnnounce7Page } from '../../pages/Officer/CreateSupportAnnounce7Page';
import { CreateSupportAnnounce8Page } from '../../pages/Officer/CreateSupportAnnounce8Page';
import { CreateSupportAnnounce9Page } from '../../pages/Officer/CreateSupportAnnounce9Page';
import { CreateSupportAnnounce10EstimatePage } from '../../pages/Officer/CreateSupportAnnounce10EstimatePage';



import { CreateSupportAnnounce10Page } from '../../pages/Officer/CreateSupportAnnounce10Page';


import { ChangeAccountFormPage } from '../../pages/SupportSystem/ChangeAccountFormPage';
import { SupportResultReportPage } from '../../pages/SupportSystem/SupportResultReportPage';

export function AppSupport() {

    return (

        <Routes>
            <Route element={<PrivateRoute />}>

                <Route
                    path="/"
                    element={<TableLandingSupportPage />}
                />
                <Route
                    path="/change-account-form"
                    element={<ChangeAccountFormPage />}
                />
                <Route
                    path="/support-result"
                    element={<SupportResultReportPage />}
                />

                {/* แบบฟอร์มเงินอุดหนุนสำหรับเจ้าหน้าที่ */}
                <Route
                    path="Form/create-support-announce4/"
                    element={<CreateSupportAnnounce4Page />}
                />
                <Route
                    path="Form/create-support-announce5/"
                    element={<CreateSupportAnnounce5Page />}
                />
                <Route
                    path="Form/create-support-announce6/"
                    element={<CreateSupportAnnounce6Page />}
                />
                <Route
                    path="Form/create-support-announce7/"
                    element={<CreateSupportAnnounce7Page />}
                />
                <Route
                    path="Form/create-support-announce8/"
                    element={<CreateSupportAnnounce8Page />}
                />
                <Route
                    path="Form/create-support-announce9/"
                    element={<CreateSupportAnnounce9Page />}
                />
                <Route
                    path="Form/create-support-announce10/"
                    element={<CreateSupportAnnounce10Page />}
                />
                <Route
                    path="Form/create-support-announce10Estimate/"
                    element={<CreateSupportAnnounce10EstimatePage />}
                />
                <Route
                    path="Form/DetailSupportFormForTest/"
                    element={<DetailSupportFormTestPage />}
                />
                <Route
                    path="Form/DetailSupportFormForEntrepreneurAnnounce6/"
                    element={<DetailSupportFormAnnounce6Page />}
                />
                <Route
                    path="Form/DetailSupportFormForEntrepreneurAnnounce7"
                    element={<EntrepreneurAnnounce7FormPage />}
                />
                <Route
                    path="Form/DetailSupportFormForEntrepreneurAnnounce8"
                    element={<EntrepreneurAnnounce8FormPage />}
                />
                <Route
                    path="Form/DetailSupportFormForEntrepreneurAnnounce9"
                    element={<EntrepreneurAnnounce9FormPage />}
                />
                <Route
                    path="Form/EstimateAnnounce11Form"
                    element={<EstimateAnnounce11FormPage />}
                />

                {/* ขอหลักสูตรนวัตกรรม */}
                <Route
                    path="Form/DetailSupportFormForEntrepreneurInnovationAnnounce10"
                    element={<EntrepreneurAnnounce10FormInnovationPage />}
                />
                <Route
                    path="Form/DetailSupportFormForEntrepreneurAnnounce10Ch24"
                    element={<EntrepreneurCh24Announce10FormPage />}
                />

                <Route
                    path="Form/DetailInnovationCourse"
                    element={<DetailInnovationCoursePage />}
                />
                <Route
                    path="Form/DetailInnovationPersonTrainAndExpected"
                    element={<DetailInnovationPersonTrainAndExpectedPage />}
                />

                <Route
                    path="Form/DetailInnovationPersonTrain"
                    element={<DetailInnovationPersonTrainPage />}
                />

                <Route
                    path="Form/DetailAndAllowcateForEstimate"
                    element={<DetailAndAllocateForEstimatePage />}
                />
                <Route
                    path="Form/DetailAndAllowcateForSkillDevelopment"
                    element={<DetailAndAllocateForSkillDevelopmentPage />}
                />
                <Route
                    path="Form/transferforofficer"
                    element={<TransferforofficerPage />}
                />
                <Route
                    path="Form/transferforofficer13"
                    element={<Transferforofficer13Page />}
                />

                <Route
                    path="support/ApproveInnovationAnnouce10"
                    element={<ApproveInnovationAnnouce10Page />}
                />
                <Route
                    path="support/ApproveInnovationAnnouce10Detail"
                    element={<ApproveInnovationAnnouce10DetailPage />}
                />

                {/* -------------------reports------------------- */}
                <Route
                    path="reports/AllocatedAndSubsidies38"
                    element={<ReportAllocatedAndSubsidies38Page />}
                />
                <Route
                    path="reports/AllocatedAndSubsidies39"
                    element={<ReportAllocatedAndSubsidies39Page />}
                />
                <Route
                    path="reports/AllocatedAndSubsidies40"
                    element={<ReportAllocatedAndSubsidies40Page />}
                />
                <Route
                    path="reports/AllocatedAndSubsidies41"
                    element={<ReportAllocatedAndSubsidies41Page />}
                />
                <Route
                    path="reports/AllocatedAndSubsidies42"
                    element={<ReportAllocatedAndSubsidies42Page />}
                />

                <Route
                    path="reports/report55"
                    element={<Report55Page />}
                />
                <Route
                    path="reports/report56"
                    element={<Report56Page />}
                />
                <Route
                    path="reports/report57"
                    element={<Report57Page />}
                />
                <Route
                    path="reports/report58"
                    element={<Report58Page />}
                />
                <Route
                    path="reports/report59"
                    element={<Report59Page />}
                />
                <Route
                    path="reports/report60"
                    element={<Report60Page />}
                />
                <Route
                    path="reports/report61"
                    element={<Report61Page />}
                />
                <Route
                    path="reports/report62"
                    element={<Report62Page />}
                />
                <Route
                    path="reports/report63"
                    element={<Report63Page />}
                />

                {/* แบบรายงานการดำเนินงาน */}
                <Route
                    path="operation/OperationReport3"
                    element={<OperationReportForm3Page />}
                />
                <Route
                    path="operation/OperationReport31"
                    element={<OperationReportForm31Page />}
                />
                <Route
                    path="operation/OperationReport32"
                    element={<OperationReportForm32Page />}
                />
                <Route
                    path="operation/AdminCheck"
                    element={<AdminCheckOperationReportsPage />}
                />

                <Route
                    path="reports"
                    element={<ListReportSupportPage />}
                />
                <Route
                    path="reportsrequest"
                    element={<ListReportSupportRequestPage />}
                />
                <Route
                    path="reportssubmitrequest"
                    element={<ListReportSupportSubmitRequestPage />}
                />
                <Route
                    path="viewsupportreport4"
                    element={<ListReportViewSupport4Page />}
                />



                {/* จนท ตรวจสอบคำขอเงินอุดหนุน */}



                {/* หน้าจอตรวจสอบ */}
                <Route
                    path="admin/CheckCondition"
                    element={<SupportAdminConditionPage />}
                />
                <Route
                    path="admin/Check"
                    element={<SupportAdminCheckPage />}
                />
                <Route
                    path="admin/Check/Detail"
                    element={<SupportAdminDetailPage />}
                />
                <Route
                    path="admin/Check/AdminCheckDetailTransfer"
                    element={<SupportDetailAdminCheckTransferPage />}
                />

                {/* view report */}

                <Route
                    path="report/viewreport4"
                    element={<ViewSupport4Page />}
                />
                <Route
                    path="report/viewreport41"
                    element={<ViewSupport41Page />}
                />
                <Route
                    path="report/viewreport42"
                    element={<ViewSupport42Page />}
                />
                <Route
                    path="report/viewreport43"
                    element={<ViewSupport43Page />}
                />
                <Route
                    path="report/viewreport44"
                    element={<ViewSupport44Page />}
                />
                <Route
                    path="report/viewreport45"
                    element={<ViewSupport45Page />}
                />
                <Route
                    path="report/viewreport46"
                    element={<ViewSupport46Page />}
                />
                <Route
                    path="report/viewreport47"
                    element={<ViewSupport47Page />}
                />
                <Route
                    path="report/viewreport48"
                    element={<ViewSupport48Page />}
                />
                <Route
                    path="report/viewreport49"
                    element={<ViewSupport49Page />}
                />
                <Route
                    path="report/viewreport410"
                    element={<ViewSupport410Page />}
                />
                <Route
                    path="report/viewreport411"
                    element={<ViewSupport411Page />}
                />
                <Route
                    path="report/Addviewreport47"
                    element={<AddViewSupport47Page />}
                />
                <Route
                    path="report/Addviewreport48"
                    element={<AddViewSupport48Page />}
                />
                <Route
                    path="report/Addviewreport49"
                    element={<AddViewSupport49Page />}
                />
                <Route
                    path="report/Addviewreport410"
                    element={<AddViewSupport410Page />}
                />
                <Route
                    path="report/Addviewreport411"
                    element={<AddViewSupport411Page />}
                />


                <Route
                    path="admin/YearbudgetLimit"
                    element={<BudgetYearLimitDetailPage />}
                />

                {/* แบบรายงานผลการพิจารณาอนุมัติ */}
                <Route
                    path="report/ApprovalConsiderationAnnounceEight"
                    element={<ApprovalConsiderationAnnounceEightPage />}
                />

                <Route
                    path="report/ApprovalConsiderationAnnounceFour"
                    element={<ApprovalConsiderationAnnounceFourPage />}
                />

                <Route
                    path="report/ApprovalConsiderationAnnounceEleven"
                    element={<ApprovalConsiderationAnnounceElevenPage />}
                />

                <Route
                    path="report/ApprovalConsiderationAnnounceSeven"
                    element={<ApprovalConsiderationAnnounceSevenPage />}
                />

                <Route
                    path="report/ApprovalConsiderationAnnounceNine"
                    element={<ApprovalConsiderationAnnounceNinePage />}
                />

                <Route
                    path="report/ApprovalConsiderationAnnounceFive"
                    element={<ApprovalConsiderationAnnounceFivePage />}
                />

                <Route
                    path="report/ApprovalConsiderationAnnounceSix"
                    element={<ApprovalConsiderationAnnounceSixPage />}
                />

                <Route
                    path="moveSupportId"
                    element={<MoverSupportIdPage />}
                />

                <Route
                    path="manage-criteria"
                    element={<ManageCriteriaPage />}
                />

                <Route
                    path="import-members-announce4"
                    element={<ImportListMemberAnnounce4Page />}
                />



            </Route>


            <Route path="*" element={<Navigate to="/" replace={true} />} />
        </Routes>

    );

}